// extracted by mini-css-extract-plugin
module.exports = {"input":"VoucherCode_input__k0Uft"};